import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ShopConfigService } from 'src/app/connect-api/api/shop/shop-config.service';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
  selector: 'app-shopping-error-detail',
  templateUrl: './shopping-error-detail.component.html',
  styleUrl: './shopping-error-detail.component.scss'
})
export class ShoppingErrorDetailComponent implements OnInit {
  private fb = inject(FormBuilder);
  private route = inject(ActivatedRoute);
  private shopConfigService = inject(ShopConfigService);
  private messageService = inject(MessageService);

  iconOptions = [
    {
      label: 'Cartão com erro',
      value:
        'https://storage.googleapis.com/b4a-modal-errors/card-with-error.svg'
    },
    {
      label: 'Erro',
      value: 'https://storage.googleapis.com/b4a-modal-errors/error.svg'
    },
    {
      label: 'Produto sem estoque (limit)',
      value: 'https://storage.googleapis.com/b4a-modal-errors/product.svg'
    },
    {
      label: 'Produto sem estoque (out)',
      value: 'https://storage.googleapis.com/b4a-modal-errors/product2.svg'
    },
    {
      label: 'Aviso',
      value: 'https://storage.googleapis.com/b4a-modal-errors/warning.svg'
    },
    {
      label: 'Sucesso',
      value: 'https://storage.googleapis.com/b4a-modal-errors/success.svg'
    }
  ];

  form: FormGroup = this.fb.group({
    icon: [''],
    code: ['', { disabled: true }],
    title: [''],
    description: ['', { disabled: true }],
    message: [''],
    buttonText: ['']
  });

  async ngOnInit() {
    LoaderService.showLoader();
    const code = this.route.snapshot.paramMap.get('code');
    if (code) {
      const errors = await this.shopConfigService.getErrorsList();
      const error = errors.find((e: any) => e.code == code);
      if (error) {
        const iconObj =
          this.iconOptions.find((opt) => opt.value === error.icon) || null;
        this.form.patchValue({
          icon: iconObj,
          code: error.code,
          title: error.title,
          message: error.message,
          description: error.description,
          buttonText: error.buttonText
        });
      }
    }

    LoaderService.showLoader(false);
  }

  async updateError() {
    LoaderService.showLoader();
    try {
      const errorData = {
        ...this.form.getRawValue()
      };
      errorData.icon = errorData.icon?.value || null;

      await this.shopConfigService.updateError(errorData);

      this.messageService.add({
        severity: 'success',
        detail: `Categoria atualizada com sucesso!`,
        summary: 'Sucesso'
      });
      LoaderService.showLoader(false);
    } catch (error) {
      LoaderService.showLoader(false);
    }
  }
}
